import {Outlet} from "react-router-dom";
import {AppShell} from "@mantine/core";
import {useDisclosure} from "@mantine/hooks";
import Header from "./header/Header";
import LayoutContext from "./LayoutContext";
import Navbar from "./navbar/Navbar";
import {useState} from "react";

type LayoutProps = {}

const navbarWidth = 260;

/**
 * Basic layout [for authenticated users only]
 * @param _props
 * @constructor
 * @author Kacper Faber
 * @since 0.1.0
 */
function Layout(_props: LayoutProps) {
    /**
     * If is subpage, layout will be displayed without navbar.
     * But we'll get back button.
     * @author Kacper Faber
     * @since 0.1.8
     */
    const [isSubPage, setIsSubPage] = useState(true);
    const [mobileOpened, { toggle: toggleMobile }] = useDisclosure();
    const [desktopOpened, { toggle: toggleDesktop }] = useDisclosure(true);

    const getNavbarWidth = () => {
        return isSubPage ? 0 : navbarWidth;
    };

    return (
        <LayoutContext.Provider value={{ mobileOpened, toggleDesktop, toggleMobile, desktopOpened, isSubPage, setIsSubPage}}>
            <AppShell
                header={{ height: 70 }}
                navbar={{width: getNavbarWidth(), breakpoint: 'xs', collapsed: { mobile: !mobileOpened, desktop: !desktopOpened }}}
                padding="md"
            >
                <Header/>

                { isSubPage ? null : <Navbar/> }

                <AppShell.Main bg="background.0">
                    <Outlet/>
                </AppShell.Main>
            </AppShell>
        </LayoutContext.Provider>
    );
}

export default Layout;